import {
  AfterViewChecked,
  AfterViewInit,
  ApplicationRef,
  Component,
  ComponentFactoryResolver,
  EventEmitter,
  Injector,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { CdkPortal, DomPortalHost } from '@angular/cdk/portal';

@Component({
  selector: 'window',
  styleUrls: ['./window.component.css'],
  templateUrl: './window.component.html',
})
export class WindowComponent implements OnInit, OnDestroy, AfterViewInit, AfterViewChecked {
  @ViewChild(CdkPortal, { static: true }) portal: CdkPortal;

  public externalWindow: Window = null;

  // tslint:disable-next-line:no-output-on-prefix
  @Output() onLoad: EventEmitter<Window> = new EventEmitter<Window>();
  @Output() onUnload: EventEmitter<Window> = new EventEmitter<Window>();

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private applicationRef: ApplicationRef,
    private injector: Injector
  ) {}

  ngOnInit() {
    // @ts-ignore
    this.externalWindow = window.open('', '', 'width=600,height=400,left=200,top=200');
    const host = new DomPortalHost(
      this.externalWindow.document.body,
      this.componentFactoryResolver,
      this.applicationRef,
      this.injector
    );

    host.attach(this.portal);
  }

  ngAfterViewInit(): void {
    this.onLoad.emit(this.externalWindow);
    this.externalWindow.onunload = () => {
      this.onUnload.emit(this.externalWindow);
    };
  }

  ngOnDestroy() {
    // this.externalWindow.close();
  }

  ngAfterViewChecked(): void {}
}
